import {css} from 'lit';
export const styles = css`:host {
  --badge-color: var(--primary);
  --button-icon-size: 23px;
  --count-label-display: none;

  border-bottom: 1px solid var(--border-light);
}

ef-badge {
  --secondary: var(--badge-color);

  margin-right: 4px;
}

.right {
  display: flex;
  align-items: center;
}

.left {
  margin-right: 16px;
}

.bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: var(--avatar-size);
  margin-top: 4px;
}

.bottom ef-label {
    margin-top: 4px;
    margin-bottom: 4px;
  }

:host([layout='column']) {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:host([layout='row']) .left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
`;
export default styles;
